import { useQuery } from 'react-query';

import { ML_API_ROUTES } from '@/api-routes';
import { axiosInstance } from '@/axios';
import type { SearchWithinType } from '@/features/ChatBotV2/context';
import type {
  AttachmentType,
  Message,
  MetadataType,
} from '@/features/ChatBotV2/types';

export const QUERY_KEY = 'askneedl-session-by-id';

export const useFetchSessionById = (sessionId?: string) => {
  return useQuery(
    [QUERY_KEY, sessionId],
    async () => {
      const response = await axiosInstance.get<{ session: SessionState }>(
        ML_API_ROUTES.askNeedlSessionById(sessionId as string)
      );
      return response;
    },
    {
      enabled: !!sessionId,
      select: (data) => data?.data?.session,
    }
  );
};

export type SessionInfo = {
  id: string;
  title: string;
  updated_at: string;
  type?: 'channel' | 'document' | 'feed' | 'home' | 'needl_universe' | 'source';
  matched_sentence?: string;
};

export type SessionState = SessionInfo & {
  state: {
    messages: Message[];
    settings: {
      pro: boolean;
    };
    search: boolean;
    searchWithin: SearchWithinType;
    currentFeedOrDocumentId: string;
    attachments?: AttachmentType[];
    attachmentsFeedId?: string;
    metadata: MetadataType;
  };
};
